import { cloud } from '../motifs';
import { GOLD, M } from '../palette';
import type { Pen } from '../pen';
import { registerPlate } from '../registry';

/** A gold post at x with a dragon's head finial looking outwards (`dir` -1 left, 1 right). */
function post(p: Pen, x: number, top: number, bottom: number, dir: number): void {
  p.rect(x - 1.5, top, 3, bottom - top, M.gold).rect(x + 0.5, top, 1, bottom - top, M.goldHi);
  p.rect(x - 1.5, top, 1, bottom - top, M.goldLo);
  for (let y = top + 4; y < bottom - 2; y += 5) p.rect(x - 2, y, 4, 1, M.goldLo).px(x + 1, y, M.goldHi);
  // The finial: a small dragon's head with a horn, a red eye and an open jaw.
  const H = (u: number, v: number): [number, number] => [x + u * dir, top + v];
  p.poly([H(-2, 0), H(-1, -4), H(2, -5), H(4.5, -4), H(5, -2.5), H(2, -2), H(4, -1), H(1, 0.5)], M.gold);
  p.line(...H(-1, -4), ...H(-3, -7), M.goldHi);
  p.px(...H(1.5, -3.5), M.red).px(...H(3.5, -4.2), M.goldHi);
  // A knob at the foot.
  p.disc(x, bottom + 1, 2, M.gold);
  p.px(x + 1, bottom, M.goldHi);
}

/** 02 ยอดฝีมือ: the master's plate, crimson lacquer between gold dragon posts, red tassels. */
registerPlate({
  id: 'master',
  name: 'ยอดฝีมือ',
  ground: ['#a02c36', M.maroon, M.maroonLo],
  trim: M.gold,
  text: { fill: [M.goldHi, M.gold], line: '#2a0a0e' },
  inset: [9, 9],
  knobs: false,
  tassels: [
    { x: -1, charm: 'knot', len: 8, cord: 4 },
    { x: 0, charm: 'knot', len: 8, cord: 4 },
  ],
  front(p, f) {
    post(p, f.x + 1, f.y - 3, f.b + 1, -1);
    post(p, f.r - 1, f.y - 3, f.b + 1, 1);
    // A gold cloud boss over the middle of the top rail.
    cloud(p, f.cx - 6, f.y + 2, 12, GOLD);
  },
  motion: {
    sprites: {
      glint: {
        w: 5,
        h: 5,
        draw: (p) => p.rect(2, 0, 1, 5, M.whiteHi).rect(0, 2, 5, 1, M.whiteHi).px(2, 2, '#ffffff'),
      },
    },
    play(a, t, f) {
      // A glint that runs along the gold, from one dragon to the other.
      const ph = (t * 0.4) % 1.6;
      if (ph < 1) a.spr('glint', f.x + 1 + ph * (f.w - 6), f.y - 1, Math.sin(ph * Math.PI));
    },
  },
});
